import React from "react";
import { Image, Button } from "semantic-ui-react";
import { motion } from "framer-motion"


export function Invisible(props) { return (<span style={{ display: "none", ...props.style }} {...props} />); }
export function MotionDiv(props) { return (<motion.div {...props} />); }

export function VanishDiv(props) {
  return (<motion.div
    initial={{ opacity: 0 }}
    animate={{ opacity: 1, transition: { delay: 0.5 } }}
    exit={{ opacity: 0 }}
    {...props}
  />);
}

export function FrameDiv(props) {
  return (<div
    {...props}
    style={{
      width: "100vw",
      height: "100vh",
      position: "fixed",
      top: 0,
      left: 0,
      ...props.style
    }}
  />);
}

export function FrameVanishDiv(props) {
  return (<motion.div
    initial={{ opacity: 0 }}
    animate={{ opacity: 1, transition: { delay: 0.5 } }}
    exit={{ opacity: 0 }}
    {...props}
    style={{
      width: "100vw",
      height: "100vh",
      position: "fixed",
      top: 0,
      left: 0,
      ...props.style
    }}
  />);
}

export function Rune(props) {

  let inactiveIcon = '../icons/' + props.icon + '-inverse.jpg';
  let activeIcon = '../icons/' + props.icon + '.jpg';

  if (props.icon === "") {
    inactiveIcon = '../icons/black.jpg';
    activeIcon = '../icons/black.jpg';
  }

  const variants = {
    glow: { scale: [1.01, 1.1, 1.01], transition: { duration: 3, ease: "easeInOut", repeat: Infinity, repeatDelay: 0.1 } },
    normal: { scale: [1.01, 1.01, 1.01] },
    runesOut: { scale: [1.01, 1.01, 0], transition: { duration: 1, ease: "easeInOut" } },
    startShuffle: { rotate: [0, 90], opacity: [1, 0], transition: { duration: 0.5, ease: "easeInOut" } },
    endShuffle: { rotate: [90, 0], opacity: [0, 1], transition: { duration: 0.5, ease: "easeInOut" } },
    startDevour: { opacity: [1, 0], transition: { duration: 0.5, ease: "easeInOut" } },
  }

  return (
    <MotionDiv
      onAnimationComplete={(d) => { if (props.onAnimationComplete != null) props.onAnimationComplete(d); }}
      animate={props.animate}
      variants={variants}
      style={{ position: "relative", ...props.style }}>

      {props.icon !== "gone" && (
        <>
          {props.backed && (<Image src='../icons/black.jpg' width="81px" circular style={{ position: "absolute", top: "0", right: "0px" }} />)}
          {props.active && (<Image src={activeIcon} width="80px" circular style={{ border: "5px green outset" }} />)}
          {!props.active && (<Image src={inactiveIcon} width="80px" circular style={{ border: "5px gray outset" }} />)}
        </>
      )}

    </MotionDiv>
  );
}


export function GlowButton(props) {

  const variants = {
    pulse: { scale: [1.01, 1.1, 1.01], transition: { duration: 3, ease: "easeInOut", repeat: Infinity, repeatDelay: 0.1 } },
    normal: { scale: [1.01, 1.01, 1.01] },
  }

  return (
    <MotionDiv
      animate={props.animate}
      variants={variants}
      style={{ position: "relative", ...props.style }}>
      <Button label={props.label} disabled={props.locked} onClick={() => { props.callbackFunction(); }}  />
    </MotionDiv>
  );
}




export class Challenge {
  constructor(title, text, runesNeeded, rewards, consequences, requiresProgress, requirements) {

    let runesFilled = [];
    for (let i = 0; i < runesNeeded.length; i++)
      runesFilled[i] = -1;

    this.title = title;
    this.text = text;
    this.textIndex = 0;
    this.runesNeeded = runesNeeded;
    this.runesFilled = runesFilled;
    this.rewards = rewards;
    this.consequences = consequences;
    this.animate = "";
    this.iconIndex = 0;
    this.resolveChallenge = null;
    this.unlocked = true;
    if(requiresProgress != null && requiresProgress) this.unlocked = false;
    this.required = "";
    this.requiredAmount = 0;
    if(requirements != null && requirements.length === 2){    
      this.required = requirements[0];
      this.requiredAmount = requirements[1];
    }
  }

  isComplete() {
    let challengeComplete = true;
    for (let i = 0; i < this.runesFilled.length; i++)
      if (this.runesFilled[i] === -1) challengeComplete = false;
    return challengeComplete;

  }
}

